import { render, staticRenderFns } from "./visualizar.vue?vue&type=template&id=583f0c48"
import script from "./visualizar.vue?vue&type=script&lang=js"
export * from "./visualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports